<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
      <header class="py-2">
        <h4><i class="fa-light fa-address-card fa-lg"></i> Cadastrar Usuário</h4>

      </header>
      <hr class="my-2">
      <b-row class="my-4">
        <b-col cols="12" sm="12" md="12" lg="8" xl="8" class="order-2 order-md-2 order-lg-1">
          <hr class="d-md-none">
          <b-form>
            <b-form-row>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  label="ID Escola:"
                  label-for="id-escola"
                  label-class="my-1 text-dark"
                >
                  <b-form-input 
                    type="text"
                    tag="input"
                    id="id-escola"
                    v-model.trim="tempIdEscola"
                    @input="updateIdEscola"
                    placeholder="Digite o ID da escola"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  label="Login:"
                  label-for="login"
                  label-class="my-1 text-dark"
                >
                  <b-form-input 
                    type="text"
                    tag="input"
                    id="login"
                    v-model.trim="login"
                    placeholder="Digite o login"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  label="Nome Completo:"
                  label-for="nome-completo"
                  label-class="my-1 text-dark"
                >
                  <b-form-input 
                    type="text"
                    tag="input"
                    id="nome-completo"
                    v-model.trim="nome"
                    placeholder="Nome completo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  label="E-mail:"
                  label-for="usuario-email"
                  label-class="my-1 text-dark"
                >
                  <b-form-input 
                    type="text"
                    tag="input"
                    id="usuario-email"
                    v-model.trim="email"
                    placeholder="Digite o e-mail"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  label="Senha:"
                  label-for="password"
                  label-class="my-1 text-dark"
                >
                  <b-input-group>
                    <b-form-input 
                      :type="typeInput"
                      tag="input"
                      id="password"
                      v-model="senha"
                      placeholder="********"
                    ></b-form-input>
                    <b-input-group-append @click="showPassword" is-text>
                      <i :class="typeInput === 'password' ? 'far fa-eye' : 'far fa-eye-slash'"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <!-- <b-form-group
                  label="Confirmar senha:"
                  label-for="confirm-password"
                  label-class="my-1 text-dark"
                >
                  <b-input-group>
                    <b-form-input 
                      :type="typeInput"
                      tag="input"
                      id="confirm-password"
                      v-model="confirmPassword"
                      placeholder="********"
                    ></b-form-input>
                    <b-input-group-append @click="showPassword" is-text>
                      <i :class="typeInput === 'password' ? 'far fa-eye' : 'far fa-eye-slash'"></i>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group> -->
              </b-col>
            </b-form-row>
          </b-form>
          <div v-if="!loading && cria_user.data.length != 0">
            <b-alert fade variant="success" v-if="cria_user.data.criandoUsuarios.erro === 0" show>
              <span><i class="far fa-face-smile-wink fa-lg"></i> {{ 'Usuário criado com sucesso ID: ' + cria_user.data.criandoUsuarios.idUsuario }}</span>
            </b-alert>
          </div>
          <div v-if="!loading && cria_user.data.length != 0">
            <b-alert fade variant="danger" v-if="cria_user.data.criandoUsuarios.erro !== 0" show>
              <span><i class="far fa-face-pensive fa-lg"></i> <strong>{{ 'Erro: ' + cria_user.data.criandoUsuarios.erro }}</strong> - 
              {{ cria_user.data.criandoUsuarios.msg }}</span>
            </b-alert>
          </div>
          <hr class="d-md-none">
          <div v-if="!loading" class="d-flex flex-column flex-md-row align-items-center justify-content-lg-center">
            <b-button class="order-2 order-md-1 btn-clear mr-lg-2" variant="transparent" @click="clearForm()">Limpar</b-button>
            <b-button class="order-1 order-md-2 btn-confirm" variant="transparent" @click="pos_cria_user()">Cadastrar</b-button>
          </div>
          <div v-if="!!loading" class="d-flex align-items-center justify-content-center">
            <b-spinner type="grow" label="carregando..." variant="success"></b-spinner>
          </div>
        </b-col>
        <b-col cols="12" md="12" lg="4" xl="4" class="order-1 order-md-1 order-lg-2">
          <h5 class="font-weight-bolder mt-3">Dúvidas de como usar?</h5>
          <hr class="mt-1 mb-3" />
          <p>Você precisa do ID da escola cadastrada previamente.</p>
          <p>Consulte a <strong>Lista de Escolas</strong> para cadastrar.</p>
          <p>Caso não exista, faça o cadastro na <strong>Aba Escola</strong> e <strong>Cadastrar</strong>.</p>
          <p>Um <strong>ID</strong> será gerado, é preciso que anote.</p>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center">
        {{ error503 }}
        <p>Você não tem permissão para visualizar este conteúdo.</p>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import ApiService from '../../../../../common/api.service';

import { FormGroupPlugin } from 'bootstrap-vue';
Vue.use(FormGroupPlugin)

import { InputGroupPlugin } from 'bootstrap-vue';
Vue.use(InputGroupPlugin);

import { FormInputPlugin } from 'bootstrap-vue';
Vue.use(FormInputPlugin);

import { AlertPlugin } from 'bootstrap-vue';
Vue.use(AlertPlugin);

import { ButtonPlugin } from 'bootstrap-vue';
Vue.use(ButtonPlugin);

import { ButtonGroupPlugin } from 'bootstrap-vue';
Vue.use(ButtonGroupPlugin);

export default {
  name: 'criar-usuario-super-pro',
  data() {
    return {
      nome: '',
      email: '',
      idEscola: '',
      login: '',
      senha: '',
      confirmPassword: '',
      cria_user: { data: [] },
      tempIdEscola: '',
      typeInput: '',
      loading: false,
    };
  },
  async mounted() {
    if (this.$route.query.loading) {
      this.isLoading = true;
      try {
        await this.fetchData();
      } catch (error) {
        console.error("ERROR loading data: ", error)
      }
    }
  },
  created() {
    this.showPassword();
  },
  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },


  methods: {
    async fetchData() {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    },
    showPassword() {
      this.typeInput = this.typeInput === 'password' ? 'text' : 'password'
    },

    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    pos_cria_user() {
      this.idEscola = this.tempIdEscola;
      this.loading = true;

      ApiService.get('v1/criar-usuarios', {
        nome: this.nome,
        email: this.email,
        idEscola: this.idEscola,
        login: this.login,
        senha: this.senha,
      })
        .then((response) => {
          this.cria_user = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => { 
          setTimeout(() => {
            this.loading = false
          }, 1000)
        });
    },

    updateIdEscola(event) {
      // Pegue o valor do input
      let inputValue = event.target.value;
      // Remova caracteres não numéricos
      let cleanValue = inputValue.replace(/[^\d]/g, '');
      // Atualize o valor
      this.tempIdEscola = cleanValue;
    },
    clearForm() {
      this.tempIdEscola = '',
      this.login = '',
      this.nome = '',
      this.email = '',
      this.senha = '',
      this.confirmPassword = ''
    }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

h4 {
  margin-bottom: 0;
}

.btn-confirm, .btn-clear {
  width: 25%;
  margin: 10px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  padding: 8px 16px;
}

.btn-confirm {
  border: 1px solid #805dca;
  color: #805dca;

  background-image: none;
  background: linear-gradient(90deg, #805dca 0%, #805dca 50%, transparent 50%, transparent 100%);
  background-size: 200% 100%;
  background-position: right;
  transition: background 0.5s ease, color 0.5s ease, border 0.5s ease;
}

.btn-confirm {
  border: 1px solid #805dca;
  color: #805dca;

  background-image: none;
  background: linear-gradient(90deg, #805dca 0%, #805dca 50%, transparent 50%, transparent 100%);
  background-size: 200% 100%;
  background-position: right;
  transition: background 0.5s ease, color 0.5s ease, border 0.5s ease;
}

.btn-clear {
  border: 1px solid #c82333;
  color: #c82333;

  background-image: none;
  background: linear-gradient(90deg, #c82333 0%, #c82333 50%, transparent 50%, transparent 100%);
  background-size: 200% 100%;
  background-position: right;
  transition: background 0.5s ease, color 0.5s ease, border 0.5s ease;
}

.btn-confirm:hover,
.btn-clear:hover {
  background-position: left;
  color: #fff;
}

.btn-confirm:focus {
  box-shadow: 0 0 0 0.2rem rgba(128, 93, 202, 0.25);
}

.btn-clear:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

.help {
  color: #805dca;
  font-style: italic;
  font-weight: 600;
}

@media only screen 
  and (max-width: 768px) {
    .btn-clear, .btn-confirm {
      width: 100%;
      margin: 5px 0;
    }
}
</style>
